import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import img from "../../assets/home/contact-property.jpeg";
import { FaHome } from "react-icons/fa";

const PropertyDetails = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000,
      easing: "ease-in-out",
      once: true,
      mirror: false,
    });
  }, []);

  return (
    <React.Fragment>
      <div className="flex flex-col items-center justify-center gap-y-4 sm:gap-y-6 md:gap-y-8 mt-5">
        <p
          className="text-[#0B68F2] text-[15px] sm:text-[16px] md:text-[17px] flex items-center space-x-3"
          data-aos="fade-down"
        >
          <FaHome />
          <span>TRUSTED REAL ESTATE CARE</span>
        </p>
        <h1
          className="text-primaryTextColor text-[30px] sm:text-[35px] md:text-[45px] font-bold text-center"
          data-aos="fade-up"
        >
          Looking For Buying Property
        </h1>
      </div>
      <div
        className="grid grid-cols-1 lg:grid-cols-2 items-start gap-6 px-4 md:px-6 lg:px-10 rounded-lg w-full mx-auto mt-6 lg:mt-10"
        data-aos="fade-up"
      >
        <div data-aos="fade-right">
          <img
            src={img}
            alt="Property"
            className="w-full h-full rounded-lg shadow-md object-cover mb-5"
          />
        </div>

        <div className="space-y-4 p-4 lg:p-6" data-aos="fade-left">
          <h2 className="text-xl sm:text-2xl font-semibold">
            Browse our exclusive property listings and discover your perfect
            home with premium features, modern amenities, and a lifestyle
            tailored just for you
          </h2>

          <ul className="list-disc pl-5 text-gray-700 mt-4">
            <li>Living rooms are pre-wired for surround sound systems</li>
            <li>Luxurious interior design with high-end finishes</li>
            <li>Nestled in a prime and peaceful neighborhood</li>
            <li>Spacious bedrooms with ample natural lighting</li>
            <li>Modern kitchen equipped with top-quality appliances</li>
            <li>24/7 security with gated community access</li>
          </ul>
        </div>
      </div>
    </React.Fragment>
  );
};

export default PropertyDetails;
